import SettingStore from "stores/settings";

export const useDisplayLearningActivityCardImage = () => {
  return SettingStore.getSettingValue("showcourseimageinportal") === "1";
};
